import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgChevronDownIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="#353C4A"
        fillRule="evenodd"
        d="m25.207 14.2-9.208 9.192L6.808 14.2l1.414-1.414L16 20.564l7.793-7.779z"
        clipRule="evenodd"
      />
    </svg>,
  );
};
export default SvgChevronDownIcon;
